import { useMemo } from 'react';

import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';
import { cls } from '@/utils/cls';

type OrgPickerProps = {
  organizations: string[];
  className?: string;
};
export function OrgPicker({ organizations, className }: OrgPickerProps) {
  const auth = useAuth();
  const me = useMe();

  const DEMO_ORG = 'demo_bess';

  // Separate demo organization from customer organizations and sort customers alphabetically for fast scanning.
  const { customerOrgs, hasDemoOrg } = useMemo(() => {
    const customers = organizations.filter((org) => org !== DEMO_ORG).sort();
    return {
      customerOrgs: customers,
      hasDemoOrg: organizations.includes(DEMO_ORG),
    };
  }, [organizations]);

  return (
    <select
      value={me.tenant}
      onChange={(e) => auth.switchOrganization(e.target.value)}
      className={cls('border-0 bg-transparent p-0', className)}
    >
      {hasDemoOrg && (
        <optgroup label="Demo (Deprecated)">
          <option value={DEMO_ORG}>{DEMO_ORG}</option>
        </optgroup>
      )}

      {customerOrgs.length > 0 && (
        <optgroup label="Customers">
          {customerOrgs.map((org) => (
            <option key={org} value={org}>
              {org}
            </option>
          ))}
        </optgroup>
      )}
    </select>
  );
}
